module.exports = __webpack_public_path__ + "static/media/uni_michigan.f6bc27ca.png";